import {isMobile} from "react-device-detect";
import { debounce } from 'javascripts/utils/debounce';

// donut charts for company size data. Using Google Charts
// https://developers.google.com/chart/interactive/docs/gallery/piechart

const initGoogleCharts = (charts, chartType='pie') => {

    const s = document.createElement("script");
    s.async = true;
    s.src = 'https://www.gstatic.com/charts/loader.js';
    document.head.append(s);
    s.onload = loadAndDrawChart;
    window.onresize = debounce(drawChart, 250);

    function loadAndDrawChart() {
        google.charts.load("current", {packages: ["corechart"]});
        google.charts.setOnLoadCallback(drawChart);
    }

    function drawChart() {
        let chartColors = ['#70CACA', '#785CA7', '#E94A7E'];
        let chartYellowColors = ['#FFD700', '#ffef9e', '#FFF7CC', '#E5E6E1']; // first is primary
        let chartAreaProps = isMobile ? {left: 0, right: 0} : { width: '100%', height: '100%' };

        charts.forEach((chart) => {
            const options = {
                pieHole: 0.8,
                legend: {
                    position: 'labeled',
                    textStyle: {fontName: 'Lato', fontSize: 12}
                },
                pieSliceText: 'none',
                chartArea: chartAreaProps,
                backgroundColor: 'transparent',
                tooltip: { trigger: 'none' },
                sliceVisibilityThreshold: 0
            };

            let element = document.getElementById(chart.id);
            if(element) {
                let colors = chart.colors == 'default' ? chartColors : chartYellowColors;
                if(chart.colors == 'yellow' && JSON.parse(element.dataset.chartData).length < 5) colors = ['#FFD700', '#FFF7CC', '#E5E6E1'];
                options.colors = colors;

                if(chart?.fontSize) {
                    options.fontSize = chart.fontSize;
                    options.legend.textStyle.fontSize = chart.fontSize;
                }

                if(chart?.pieHole == 0) {
                    options.pieHole = 0;
                    options.legend.position = 'none';
                    options.pieSliceText = 'percentage';
                }

                if(chartType == 'pie') {
                    let chartData = google.visualization.arrayToDataTable(JSON.parse(element.dataset.chartData));
                    let googleChart = new google.visualization.PieChart(element);
                    googleChart.draw(chartData, options);
                }
            }
        })
    }

    return drawChart; // The drawChart function is used to rerender the chart after a turbo request
}

export { initGoogleCharts }
